import { Receipt, BarChart3 } from 'lucide-react';
import HubPage from '../components/ui/HubPage';

// Hub Analítica (PR-UX1.1, piloto del patrón hub): agrupa las dos vistas de
// reporting —Contabilidad y Estadísticas— que antes eran entradas sueltas del
// sidebar. Las páginas destino siguen montadas en sus rutas originales; aquí
// solo se enlazan como tarjetas.

export default function AnaliticaPage() {
  return (
    <HubPage
      subtitle="Informes de negocio: cuadre económico y métricas de actividad."
      cards={[
        {
          to: '/contabilidad',
          icon: Receipt,
          title: 'Contabilidad',
          description: 'Ingresos, pagos y cuadre económico por periodo.',
          testid: 'hub-card-contabilidad',
        },
        {
          to: '/estadisticas',
          icon: BarChart3,
          title: 'Estadísticas',
          description: 'Métricas de actividad: alumnos, sesiones y ocupación.',
          testid: 'hub-card-estadisticas',
        },
      ]}
    />
  );
}
